// extracted by mini-css-extract-plugin
export default {"total-subtotal":"OrderSummaryTotalAmount-module__total-subtotal__exKWL","total":"OrderSummaryTotalAmount-module__total__fazzV"};